import React, { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaGlobe } from "react-icons/fa";
import { getAllboothsList, getCities, groupByCity } from "../../services/Booths";
import { useNavigate } from "react-router-dom";
import ls from "local-storage";
import { event } from "../../utils/gtag";
import { useLocation } from "react-router-dom";

const links = [
  { label: "📝 DAFTAR SUKHAKALA COMMUNITY BATCH 02", url: "https://forms.gle/YWgk2ZkvqcTFFmC97" },
  { label: "📍 BOOTH LOCATION", url: "/locations" },
  { label: "⭐️ SUKHAKALA GIFT CARD", url: "https://giftcard.sukhakala.id/" },

  { label: "⭐️ BUNDLE BANDEL - Foto 3x cuma 80k", url: "https://bundlebandel.sukhakala.id/" },
  {
    label: "📸 PARTNERSHIP / BOOTH PLACEMENT FORM",
    url: "https://forms.gle/yJehYBc4QJaaXVhr9",
  },
  {
    label: "📸 PHOTOBOOTH PUBLIC EVENT FORM (KONSER, PENSI)",
    url: "https://docs.google.com/forms/d/1JncoiVwUrBeUn817Rn_JG_ELYgVg6RS9PtPBGQi7RNI/edit",
  },
  {
    label: "📸 PHOTOBOOTH PRIVATE FORM (WEDDING , BIRTHDAY, COMPANY GATHERING)",
    url: "https://forms.gle/FzDvWtcoG6nP8vePA",
  },
  { label: "📝 FRAME COLLAB FORM", url: "https://forms.gle/v7uzCHNhV3ooqaNk7" },
  {
    label: "✨FRAME COLLAB LIST",
    url: "https://collab.sukhakala.id",
  },
  { label: "📱 FOLLOW US ON TIKTOK✨", url: "https://www.tiktok.com/@sukhakala.id?is_from_webapp=1&sender_device=pc" },
  { label: "💰 REFUND FORM", url: "/refund" },
];

const socials = [
  {
    icon: <FaInstagram />,
    url: "https://instagram.com/sukhakala.id",
  },
  {
    icon: <FaTiktok />,
    url: "https://tiktok.com/@sukhakala.id",
  },
  {
    icon: <FaGlobe />,
    url: "https://sukhakala.id",
  },
];

export default function LinksPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const utmSource = params.get("utm_source");

  useEffect(() => {
    if (utmSource && window.gtag) {
      window.gtag("set", "user_properties", {
        utm_source: utmSource,
      });
    }
  }, [utmSource]);

  function fetchLS() {
    if (ls.get("userDetail")) {
      const userDetail = ls.get("userDetail");
    }
  }
  useEffect(() => {
    fetchLS();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50 flex flex-col items-center px-4 py-8">
      <img src="/latest-logo.jpg" alt="Sukhakala Logo" className="w-24 h-24 mb-4 rounded-full object-cover" />
      <h1 className="text-3xl font-bold text-center mb-2">Sukhakala Photobooth</h1>
      <p className="text-center text-gray-700 mb-4" style={{ display: "none" }}>
        Temukan lokasi booth Sukhakala di berbagai kota, ajukan kolaborasi event atau penempatan booth, dan akses semua
        link penting ekosistem Sukhakala. Kolaborasi dengan partner, event, dan media sosial kami!
      </p>
      Keeping memories alive with the new ✨love language✨
      <br />
      <br />
      {/* Social Icons */}
      <div className="flex space-x-4 mb-8">
        {socials.map((social, idx) => (
          <a
            key={idx}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              event({
                action: "click_link",
                category: "LinksPage",
                label: social.url,
              })
            }
            className="text-2xl text-pink-600 hover:text-pink-800 transition"
          >
            {social.icon}
          </a>
        ))}
      </div>
      {/* Links */}
      <div className="flex flex-col gap-4 w-full max-w-md">
        {links.map((link, idx) => (
          <a
            key={idx}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#2b478e] text-white text-center py-3 px-6 rounded-xl shadow hover:bg-[#e7ac46] transition"
            onClick={() =>
              event({
                action: "click_link",
                category: "LinksPage",
                label: link.label,
              })
            }
          >
            {link.label}
          </a>
        ))}
      </div>
      {/* Hidden SEO keywords for Indonesian search */}
      <div style={{ display: "none" }}>
        sukhakala photobooth, lokasi sukhakala, photobooth jakarta, photobooth bandung, photobooth surabaya, photobooth
        bali, photobooth yogyakarta, photobooth semarang, photobooth medan, photobooth palembang, photobooth makassar,
        kolaborasi sukhakala, event sukhakala, partner sukhakala, penempatan booth sukhakala, kolaborasi acara
        sukhakala, sukhakala event, sukhakala partner, sukhakala booth, sukhakala social media
      </div>
    </div>
  );
}
